import moment from 'moment';

export const dateDef = (date) => {
    return moment(date).format('DD MMMM YYYY, HH:mm');
}

export const dateTimeInput = (date) => {
    return moment(date).format('MM-DD-YYYY HH:mm');
}